import { render, staticRenderFns } from "./QAZone.vue?vue&type=template&id=dcd99692&scoped=true"
import script from "./QAZone.vue?vue&type=script&lang=js"
export * from "./QAZone.vue?vue&type=script&lang=js"
import style0 from "./QAZone.vue?vue&type=style&index=0&id=dcd99692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd99692",
  null
  
)

export default component.exports